/**
 * @name isLighthouse
 * @description Is the current user a Google lighthouse user agent
 */
export const isLighthouse = (userAgent: string): boolean =>
  userAgent.includes('Chrome-Lighthouse');
